import React from "react"
import HelpWidgetChartInteractiveMolecule from "views/molecules/interactive/HelpWidgetChartInteractiveMolecule"
import {
  TextChart,
  TextChartMinor,
} from "components/widgets/ScorePage/widgets/TextCharts"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"
import ChartBadge from "views/atoms/badges/ChartBadge"
import { convertValueToReadable } from "services/units/valueConversion"
import { CO2_EMISSION_UNITS, G_CO2E } from "services/units/units"
import { round } from "services/units/round"
import Unit from "views/atoms/reports/Unit"
import ChartWithBadgeWrapperMolecule from "views/molecules/charts/ChartWithBadgeWrapperMolecule"

const ChartSDG13GhgEmissionsPerVisitKPIMolecule = ({
  ghgEmissionsPerVisit,
  lowerLimit,
  upperLimit,
  trendBadge
}) => {
  const { t } = useTranslation()

  const translatePrefix = "analyze:websites.ghg_emissions_per_visit"

  const badge = (
    <ChartBadge
      lowerLimit={lowerLimit}
      upperLimit={upperLimit}
      inverse
      value={ghgEmissionsPerVisit}
    />
  )
  const content = {
    reference: badge,
    kpi: ghgEmissionsPerVisit,
    kpi_text: t(`${translatePrefix}.title`),
  }

  const {
    value: ghgEmissionsPerVisitValue,
    unit: ghgEmissionsPerVisitUnit,
  } = convertValueToReadable(
    ghgEmissionsPerVisit,
    G_CO2E,
    CO2_EMISSION_UNITS,
    (v) => round(v, 1)
  )

  content.kpi = `${ghgEmissionsPerVisitValue}`
  content.kpi_unit = (
    <>
      <Unit unit={t(`units:units.emission.${ghgEmissionsPerVisitUnit}`)} />
      {t(`${translatePrefix}.suffix_unit`)}
    </>
  )

  return (
    <HelpWidgetChartInteractiveMolecule text={t(`${translatePrefix}.help`)}>
      <ChartWithBadgeWrapperMolecule trendBadge={trendBadge} color="auto">
        <TextChart content={<TextChartMinor content={content} />} />
      </ChartWithBadgeWrapperMolecule>
    </HelpWidgetChartInteractiveMolecule>
  )
}

ChartSDG13GhgEmissionsPerVisitKPIMolecule.propTypes = {
  ghgEmissionsPerVisit: PropTypes.object.isRequired,
  lowerLimit: PropTypes.number,
  upperLimit: PropTypes.number,
  trendBadge: PropTypes.object,
}

ChartSDG13GhgEmissionsPerVisitKPIMolecule.defaultProps = {
  lowerLimit: 0.5,
  upperLimit: 1.5,
  trendBadge: null,
}

export default ChartSDG13GhgEmissionsPerVisitKPIMolecule